// extracted by mini-css-extract-plugin
module.exports = {"table":"NutritionInformation-module--table--3aAvj","title":"NutritionInformation-module--title--2CVtl","subtitle":"NutritionInformation-module--subtitle--fAlJX"};